
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { Cookies } from 'react-cookie';
import { useEffect, useState } from 'react';
import { BindReportGrid, ReverseFormatDate, OpenBase64Pdf, exportToExcel, formatDate, setFocus, setTitle } from "../Common/Common";
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";
import Loader from '../Layout/Loader';

const ReceiveRequestReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode');
    const SalesPersonName = cookies.get('userName');
    const SalesPersonCode = cookies.get('salesPersonCode')
    const [isUpdate, setIsUpdate] = useState(false)
    const [salesPerson, setSalesPerson] = useState([]);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    const [MenuText, setMenuText] = useState("Request Receipt Report");
    const [isLoading, setIsLoading] = useState(false);
    const [tableData, setTableData] = useState({})
    const [FilterData, setFilterData] = useState({
        PageIndex: "1",
        RequestSheetNo: "",
        ContactPerson: "",
        SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
        RequestSheetDateFrom: "",
        RequestSheetDateTo: "",
    });

    const HandleChange = (prop, value) => {
        setFilterData(FilterData => ({ ...FilterData, [prop]: value }));
    }

    useEffect(() => {
        setTitle('ReceiveRequestReport', setOpen);
        setFocus('txtRequestSheetNo');
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, [])

    //useEffect(() => {
    //    getRequisitionData();
    //}, [FilterData.PageIndex, isUpdate]);

  
    const getRequisitionData = async (Type = 'S', PI = FilterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...FilterData, Type: Type, Token, LoginUserCode: loginCodeString, PageIndex: `${PI}`
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Report/ShowExReceiveRequestReport`, { ...data }, (res) => {
            if (res.Status === 'SUCCESS' || res.status === 'SUCCESS') {
                if (Type === 'S') {
                    setTableData({
                        ...res
                    });
                }
                else {
                    if (Array.isArray(res.Data)) {
                        
                       exportToExcel(res.Data, 'ReceiveRequestReport');
                    }
                }
            }
            else if (res.Status === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.Message !== "") {
                AlertBox(res.Status, res.Message, res.Focus);
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            setIsLoading(false)
        })
    }

    const handlePrintData = (ID) => {
        const loginCodeString = String(LoginUserCode);
        const RequestSheetNo = ID.RequestSheetNo;

        const data = {
            RequestSheetNo: RequestSheetNo,
            Source: "Report",
            Token,
            LoginUserCode: loginCodeString
        };
        setIsLoading(true)
        post(`${API_SERVER}/api/Print/RequestReceivePrint`, { ...data }, (res) => {
            if (res.message === 'EXPIRED') {
                navigate('/Login')
            }
            else if (res.status === 'SUCCESS') {
                OpenBase64Pdf(res.documentPdfBase64, 'RequestReceivePrint_' + ID, '_blank');
            }
            else if (res.status === 'ERROR') {
                AlertBox(res.status, res.message, res.focus)
            }
            setIsLoading(false)
        });
    }

    const handleChange1 = (event, value) => {
        getRequisitionData("S", value);
        console.log(value)
    };

    const handleClearData = () => {
        setFilterData(
            {
                PageIndex: "1",
                RequestSheetNo: "",
                ContactPerson: "",
                SalesPerson: SalesPersonCode ? SalesPersonCode + ' : ' + SalesPersonName : "",
                RequestSheetDateFrom: "",
                RequestSheetDateTo: "",
            });

        setTableData(
            {
                totalRecord: 0,
                gridData: [{
                }]
            }
        );
        setFocus('txtRequestSheetNo');
        setIsUpdate(!isUpdate)
    }

    const searchHandle = async () => {
        setFilterData({
            ...FilterData,
            PageIndex: "1",
        })
        getRequisitionData();
    }

    const handleDownloadExcel = async () => {
        getRequisitionData('E');
    }

    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };

    let SalesPersonArr = []
    for (let i = 0; i < salesPerson.length; i++) {
        let mydata = salesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };

    useEffect(() => {
        if (FilterData.RequestSheetDateFrom) {
            const fromDateObj = new Date(FilterData.RequestSheetDateFrom);
            const toDateObj = new Date(FilterData.RequestSheetDateTo);

            if (
                !FilterData.RequestSheetDateTo ||
                toDateObj <= fromDateObj
            ) {
                const nextDay = new Date(fromDateObj);
                nextDay.setDate(fromDateObj.getDate() + 1);

                const formattedNextDay = formatDate(nextDay);

                setFilterData(prev => ({
                    ...prev,
                    RequestSheetDateTo: formattedNextDay
                }));
            }
        }
    }, [FilterData.RequestSheetDateFrom]);
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Request Sheet No.</label>
                                            <input
                                                maxLength="50"
                                                id='txtRequestSheetNo'
                                                type="text"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtSalesPerson')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Request Sheet No'
                                                value={FilterData.RequestSheetNo}
                                                onChange={(e) => {
                                                    setFilterData({ ...FilterData, RequestSheetNo: e.target.value.toUpperCase() })
                                                }}

                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtRequestSheetDateFrom") };
                                                }}
                                                disabled={SalesPersonCode ? true : false}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={FilterData.SalesPerson ? FilterData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    HandleChange('SalesPerson', newInputValue)

                                                }}
                                            />

                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Requisition Receive Date</label>
                                            <div className="row">
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.RequestSheetDateFrom) || null}
                                                        id='txtRequestSheetDateFrom'
                                                        className="form-control"
                                                        placeholderText='From Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, RequestSheetDateFrom: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('txtRequestSheetDateTo')
                                                            };
                                                        }}
                                                        maxDate={new Date()}
                                                    /></div>
                                                <div className="col-6">
                                                    <DatePicker selected={ReverseFormatDate(FilterData.RequestSheetDateTo) || null}
                                                        id='txtRequestSheetDateTo'
                                                        className="form-control"
                                                        placeholderText='To Date'
                                                        dateFormat={'dd-MMM-yyyy'}
                                                        autoComplete='off'
                                                        onChange={(date) => {
                                                            setFilterData({ ...FilterData, RequestSheetDateTo: formatDate(date) })
                                                        }}
                                                        onKeyDown={(e) => {
                                                            if (e.key === 'Enter') {
                                                                setFocus('btnSearch')
                                                            };
                                                        }} 
                                                        minDate={new Date(FilterData.RequestSheetDateFrom) || null}
                                                    /></div>
                                            </div>


                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            <button className="button save-btn" id='btnSearch' onClick={searchHandle}>
                                                <i className="bi bi-search" /> Search
                                            </button>
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClearData} >
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={FilterData} currentPageNo={currentPageNo} handleChange1={handleChange1} handlePrintButton={handlePrintData} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
        </main>
    )
}
export default ReceiveRequestReport